var _circle, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUiOpensea3D(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ui_opensea_3D",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_84",
    "data-name": "Ellipse 84",
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#222"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component_151_8",
    "data-name": "Component 151 \\u2013 8",
    transform: "translate(12 12)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14711",
    "data-name": "Rectangle 14711",
    width: 24,
    height: 24,
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1080",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1079"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1124",
    "data-name": "Group 1124"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1078"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2501",
    d: "M16.292,2.395,8.4-2.1.5,2.395v9.111L8.4,16l7.9-4.495ZM7.424,13.328l-5.1-2.915V4.46l5.1,2.915ZM3.294,2.881,8.4-.035l5.1,2.915L8.4,5.8ZM14.47,10.412l-5.1,2.915V7.5l5.1-3.037Z",
    transform: "translate(2.537 5.744)",
    fill: "#fff000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2502",
    d: "M7.537.6,4.5,2.3,7.537,4l3.037-1.7Z",
    transform: "translate(3.396 6.324)",
    fill: "#fff000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2503",
    d: "M5.937,6.622,2.9,4.8V8.323l3.037,1.7Z",
    transform: "translate(3.052 7.226)",
    fill: "#fff000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2504",
    d: "M-.056,6.6H-2v4.859l4.13,2.43L3.1,12.309l-3.28-1.822Z",
    transform: "translate(2 7.613)",
    fill: "#fff000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2505",
    d: "M7.73-2.913l3.28,1.822.972-1.579L7.73-5.1,3.6-2.67l.972,1.579Z",
    transform: "translate(3.203 5.1)",
    fill: "#fff000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2506",
    d: "M14.98,6.621v3.766L11.7,12.209l.972,1.579,4.13-2.43V6.5Z",
    transform: "translate(4.942 7.591)",
    fill: "#fff000"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUiOpensea3D);
export default __webpack_public_path__ + "static/media/ui_opensea_3D.c2f498d2969fe438ffc757bb4e6ffe6d.svg";
export { ForwardRef as ReactComponent };